import useCurrentUser from "data/advisor/useCurrentUser";

import { useAccess } from "components/Access";

import { useInsightInfos } from "scenes/Hubly/components/Workspace/components/InsightMenu/hooks";

export function useUserMenuManager(user) {
  const currentUser = useCurrentUser();
  const hasAccess = useAccess();
  const insights = useInsightInfos("reportButton");

  return {
    showButton: {
      editEmail: user.id === currentUser.id,
      editPassword: user.id === currentUser.id,
      sendInvite:
        ["Invite sent"].includes(user.status) && hasAccess(["Administrator"]),
      enableInsights:
        ["Active", "Invite sent"].includes(user.status) &&
        hasAccess(["Administrator"]) &&
        insights.length > 0,
      reassignTasks: hasAccess(["Administrator"]),
      replaceUser:
        !["Deactivated", "Invite not sent"].includes(user.status) &&
        hasAccess(["Administrator"]) &&
        currentUser.id !== user.id,
      deactivateUser:
        !["Deactivated", "Invite not sent"].includes(user.status) &&
        hasAccess(["Administrator"]) &&
        !user.isAccountOwner &&
        currentUser.id !== user.id,
      reactivateUser:
        ["Deactivated"].includes(user.status) &&
        hasAccess(["Administrator"]) &&
        currentUser.id !== user.id &&
        !user.isSupport,
    },
  };
}

export default useUserMenuManager;
